import TaskDetails from './container/index';

export default TaskDetails;


// WEBPACK FOOTER //
// ./src/components/page/TaskDetails/index.js